import React from "react";
import {ErrorCommon, TextField, TextFieldCommon, NumberTextField} from "../../../components/formikFormInputs";
import { Grid } from "@material-ui/core";
import { Label } from "../../formInputs";
import {useFormikContext} from "formik";
import InputAdornment from "@material-ui/core/InputAdornment";

function PaymentUserInformation(props: any) {
    const {source= "servicing", paymentMethod} = props;
    let paymentDisabled: boolean = false;
    const { values, handleChange, handleBlur, errors, touched } = useFormikContext();
    let paymentLabel: string = "Payment Amount";
    if (source === "enrollment") {
        paymentLabel = "1st Payment Due";
        paymentDisabled = true;
    } else if (paymentMethod === 4) {
        paymentLabel = "Monthly Payment Amount";
        paymentDisabled = true;
    }

    const payerDetailsFields = [
        {
            label: <Label label={"Payer First Name"} required />,
            name: "payerFirstName",
            placeholder: "Payer First Name",
            id: "payerFirstName",
            component: TextField,
            disabled: true
        },
        {
            label: <Label label={"Payer Last Name"} required />,
            name: "payerLastName",
            placeholder: "Payer Last Name",
            id: "payerLastName",
            component: TextField,
            disabled: true
        },
        {
            label: <Label label={"Tranche Number"} />,
            name: "trancheNumber",
            placeholder: "Tranche Number",
            id: "trancheNumber",
            component: TextField,
            disabled: true
        },
        {
            label: <Label label={"Funding Date"} />,
            name: "fundingDate",
            placeholder: "Funding Date",
            id: "fundingDate",
            component: TextField,
            disabled: true
        },
        {
            label: <Label label={"Payer Email"} required />,
            name: "payerEmail",
            placeholder: "Payer Email",
            id: "payerEmail",
            component: TextField,
            disabled: true
        },
        {
            label: <Label label={paymentLabel} required />,
            name: "paymentAmount",
            placeholder: paymentLabel,
            id: "paymentAmount",
            component: NumberTextField,
            InputProps: {
                startAdornment: <InputAdornment position="start"><strong>$</strong></InputAdornment>,
            },
            disabled: paymentDisabled,
        },
        {
            label: <Label label={"Recurring Payment"} />,
            name: "recurringPayment",
            placeholder: "Recurring Payment",
            id: "recurringPayment",
            component: TextField,
            disabled: true
        },
        {
            label: <Label label={"Recurring Payment Date"} />,
            name: "recurringPaymentDate",
            placeholder: "Recurring Payment Date",
            id: "recurringPaymentDate",
            component: TextField,
            disabled: true
        },
    ];

    return (
            <Grid container spacing={2}>
                {
                    payerDetailsFields.map((field, index) => {
                        return (<Grid item xs={12} sm={12} md={6} key={index}>
                            <TextFieldCommon
                                {...field}
                                values={values}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <ErrorCommon errors={errors}
                                         name={field.name}
                                         touched={touched} />
                        </Grid>);
                    })
                }
            </Grid>
    );
}

export default PaymentUserInformation;